import { LegacyIIQApi } from './legacy-iiq-api';
import {
  getAipSettings,
  createAipSettings,
  saveAipSettings,
} from './endpoints/aip-settings';
import { clearRedisCache } from './endpoints/cache';
import { getAllPreviousLgmSalesEffectiveDates } from './endpoints/fieldsOptions';
import { downloadMedia, getMediaSignedUrl } from './endpoints/media';
import {
  createOrgAppSettings,
  updateOrgAppSettings,
  deleteOrgAppSettings,
} from './endpoints/org-app-settings';
import { getRoleUsers } from './endpoints/roles';
import {
  getUserPolicies,
  updateUserProfileByUserId,
  updateUserPersonalInformations,
  updateUserBusinessInformation,
  deleteUserById,
  removeUserRole,
  addUserRole,
  assignAgent,
} from './endpoints/user';

export type LegacyIIQApiEndpoints = {
  getAipSettings: ReturnType<typeof getAipSettings>;
  createAipSettings: ReturnType<typeof createAipSettings>;
  saveAipSettings: ReturnType<typeof saveAipSettings>;
  clearRedisCache: ReturnType<typeof clearRedisCache>;
  getAllPreviousLgmSalesEffectiveDates: ReturnType<
    typeof getAllPreviousLgmSalesEffectiveDates
  >;
  downloadMedia: ReturnType<typeof downloadMedia>;
  getMediaSignedUrl: ReturnType<typeof getMediaSignedUrl>;
  createOrgAppSettings: ReturnType<typeof createOrgAppSettings>;
  updateOrgAppSettings: ReturnType<typeof updateOrgAppSettings>;
  deleteOrgAppSettings: ReturnType<typeof deleteOrgAppSettings>;
  getRoleUsers: ReturnType<typeof getRoleUsers>;
  getUserPolicies: ReturnType<typeof getUserPolicies>;
  updateUserProfileByUserId: ReturnType<typeof updateUserProfileByUserId>;
  updateUserPersonalInformations: ReturnType<
    typeof updateUserPersonalInformations
  >;
  updateUserBusinessInformation: ReturnType<
    typeof updateUserBusinessInformation
  >;
  deleteUserById: ReturnType<typeof deleteUserById>;
  removeUserRole: ReturnType<typeof removeUserRole>;
  addUserRole: ReturnType<typeof addUserRole>;
  assignAgent: ReturnType<typeof assignAgent>;
};

export function getEndpoints({
  legacyIIQApi,
}: {
  legacyIIQApi: LegacyIIQApi;
}): LegacyIIQApiEndpoints {
  return {
    getAipSettings: getAipSettings({ legacyIIQApi }),
    createAipSettings: createAipSettings({ legacyIIQApi }),
    saveAipSettings: saveAipSettings({ legacyIIQApi }),

    clearRedisCache: clearRedisCache({ legacyIIQApi }),
    getAllPreviousLgmSalesEffectiveDates: getAllPreviousLgmSalesEffectiveDates({
      legacyIIQApi,
    }),
    downloadMedia: downloadMedia({ legacyIIQApi }),
    getMediaSignedUrl: getMediaSignedUrl({ legacyIIQApi }),
    createOrgAppSettings: createOrgAppSettings({ legacyIIQApi }),
    updateOrgAppSettings: updateOrgAppSettings({ legacyIIQApi }),
    deleteOrgAppSettings: deleteOrgAppSettings({ legacyIIQApi }),
    getRoleUsers: getRoleUsers({ legacyIIQApi }),
    getUserPolicies: getUserPolicies({ legacyIIQApi }),
    updateUserProfileByUserId: updateUserProfileByUserId({
      legacyIIQApi,
    }),
    updateUserPersonalInformations: updateUserPersonalInformations({
      legacyIIQApi,
    }),
    updateUserBusinessInformation: updateUserBusinessInformation({
      legacyIIQApi,
    }),
    deleteUserById: deleteUserById({ legacyIIQApi }),
    removeUserRole: removeUserRole({ legacyIIQApi }),
    addUserRole: addUserRole({ legacyIIQApi }),
    assignAgent: assignAgent({ legacyIIQApi }),
  };
}
